import { useQuery } from "@tanstack/react-query";
import { customizationApi } from "../services/customization-service";
import { SUPPORTED_LANGUAGES } from "../utils/language";

export const SUPPORTED_LANGUAGES_QUERY_KEY = [
  "customization",
  "languages",
  "supported",
];

const LANGUAGE_LABEL_KEYS = {
  en: "settings.english",
  ar: "settings.arabic",
  ckb: "settings.kurdishSorani",
};

const FALLBACK_LANGUAGES = [
  { code: "en", name: "English", direction: "ltr" },
  { code: "ar", name: "العربية", direction: "rtl" },
  { code: "ckb", name: "کوردی (سۆرانی)", direction: "rtl" },
];

const normalizeSupportedLanguages = (languages) => {
  if (!Array.isArray(languages)) return [];

  const seen = new Set();

  return languages.flatMap((language) => {
    const code = language?.code?.trim().toLowerCase();

    if (!SUPPORTED_LANGUAGES.includes(code) || seen.has(code)) return [];

    seen.add(code);

    return [
      {
        code,
        name: language?.name?.trim() || code,
        direction: language?.direction === "rtl" ? "rtl" : "ltr",
      },
    ];
  });
};

export const useSupportedLanguages = () => {
  const query = useQuery({
    queryKey: SUPPORTED_LANGUAGES_QUERY_KEY,
    queryFn: async () => {
      const { data } = await customizationApi.getSupportedLanguages();
      return normalizeSupportedLanguages(data?.languages);
    },
    staleTime: 5 * 60 * 1000,
  });

  const languages = query.isSuccess ? query.data : FALLBACK_LANGUAGES;

  return {
    ...query,
    languages: languages.map((language) => ({
      ...language,
      labelKey: LANGUAGE_LABEL_KEYS[language.code],
    })),
  };
};
